/**
 * App Insights customEvent name for an Auth0 error that came back on the redirect URL.
 *
 * Deliberately distinct from the backend's `Auth0AuthFailure`, which the Auth0 tenant log stream
 * feeds. The two cover different halves: a failure Auth0 renders as its own error page never
 * returns to the app and so can only appear in the backend event, while this one carries the
 * app-side route the browser landed on, which the tenant log does not know.
 */
export const AUTH0_CALLBACK_ERROR_EVENT_NAME = "Auth0CallbackError";
